import { render, staticRenderFns } from "./tit-wrap-secondary.vue?vue&type=template&id=2bdd6cf0&scoped=true"
import script from "./tit-wrap-secondary.vue?vue&type=script&lang=js"
export * from "./tit-wrap-secondary.vue?vue&type=script&lang=js"
import style0 from "./tit-wrap-secondary.vue?vue&type=style&index=0&id=2bdd6cf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdd6cf0",
  null
  
)

export default component.exports